import { Component } from '@angular/core';
export class LibComponent {
  name = 'Angular Library';
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'my-lib',
  template: "<h2>Hello {{name}}</h2> ",
  styles: [""]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LibComponent_tsickle_Closure_declarations() {
/** @type {?} */
LibComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LibComponent.ctorParameters;
/** @type {?} */
LibComponent.prototype.name;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
